import React, { Component } from 'react';

import './empresa.css';
import '../estaHome.css';

import functions from '../../../../functions/Estadisticas/getData';

class Empresa extends Component {

    constructor(){
        super();
        this.state = {
            cantidadSesiones: 0
        };

        this.getCantidadSesiones();
    }

    getCantidadSesiones = () => {
        functions.GetDataSesiones().then((datos) => {
            this.setState({
                cantidadSesiones: datos
            });
        });
    }

    render(){
        return(
            <div className='col s12 m6 xl4'>
                <div className="card-panel empresaCard" id="acomodarHeight">
                    <p>Sesiones</p>
                    <h5>{this.state.cantidadSesiones}</h5>
                    <i className='large material-icons chatIcon'>chat</i>
                </div>
            </div>
        );
    }
}

export default Empresa;
